export const USER_TEMP_ROLES_ID = {
    partnerAdmin: 'partner--admin',
};
